import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
    Card,
    CardBody,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
    UncontrolledTooltip
} from "reactstrap";

import { decryptedValue, isPermission } from "common/utility";


//redux
import { callGetQuery, callGetQueryForCustomers } from "../../http/fundLync/query.helper";

// Column
import TableContainerV1 from "components/Common/TableContainerV1";


const TableActionsComponent = (rowData) =>{
    const navigate = useNavigate();
    const user = decryptedValue(localStorage.getItem("user"));
 
    const navigateToEditRoles = (id) => {
        const encryptedId = btoa(id.toString());
        if (user.entityType == 'Owner' || user.entityType == 'Partner') {
            navigate(`/${user.roleName}/viewDeal?id=${encodeURIComponent(encryptedId)}`);
        } else if (user.entityType == 'Customer') {
            navigate(`/customer/viewDeal?id=${encodeURIComponent(encryptedId)}`);
        }
    };
  
    
    return (
        <UncontrolledDropdown>
        <DropdownToggle tag="a" className="card-drop">
            <i className="mdi mdi-dots-horizontal font-size-18"></i>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
                onClick={() => { navigateToEditRoles(rowData.dealId) }
                }
            >
                <i className="mdi mdi-eye font-size-16 text-success me-1" id="edittooltip"></i>
                View
                <UncontrolledTooltip placement="top" target="edittooltip">
                    View
                </UncontrolledTooltip>
            </DropdownItem>
        </DropdownMenu>
    </UncontrolledDropdown>
    )
  }

const Queries = props => {

    //meta title
    document.title = "List Query | FundLync";

    const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action', 'UserName', 'EntityName'] })
    const [roleList, setRoleList] = useState([]);
    const [isFullAccess, setIsFullAccess] = useState(false)
    const [isListPermission, setIsListPermission] = useState(false)
    const user = decryptedValue(localStorage.getItem("user"));
    useEffect(() => {
        checkPermissions()
    }, []);

    const checkPermissions = async () => {
        const isList = await isPermission("query", "list_permission")
        const isFull = await isPermission("query", "full_access")
        
        setIsFullAccess(isFull)
        setIsListPermission(isList)
        if (isFull) {
            callGetQuery({user})
                .then((response) => {
                    if (response.code == 200 && response.status) {
                        setRoleList(response.data.data)
                        const { totalItems, totalPages, currentPage } = response.data
                        setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                    } else {
                        setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                        setRoleList([])
                    }
                }).catch((error) => {
                })
        } else {
            callGetQueryForCustomers()
                .then((response) => {
                    if (response.code == 200 && response.status) {
                        setRoleList(response.data.data)
                        const { totalItems, totalPages, currentPage } = response.data
                        setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                    } else {
                        setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                        setRoleList([])
                    }
                }).catch((error) => {
                })
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'id',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value;
                }
            },
            // {
            //     Header: 'Deal Name',
            //     accessor: 'DealName',
            //     filterable: true,
            //     Cell: (cellProps) => {
            //         const rowData = cellProps.row.original;
            //         return rowData.deal.dealName;
            //     }
            // },
            {
                Header: 'User Name',
                accessor: 'UserName',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    let user = rowData.user?.first_name + ' '
                    if(rowData.user?.last_name){
                        user += rowData.user?.last_name
                    }
                    return user
                }
            },
            {
                Header: 'Entity Name',
                accessor: 'EntityName',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.entity.entityName;
                }
            },
            {
                Header: 'Query',
                accessor: 'dealQuery',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value;
                }
            },
            {
                Header: 'Query Response',
                accessor: 'dealQueryResponse',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.dealQueryResponse?rowData.dealQueryResponse:"Pending Response";
                }
            },
            {
                Header: 'Action',
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionsComponent(rowData);
                }
            },
        ],
        []
    );

    const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
        setPageSize(pageSize);
        if (isFullAccess) {
            callGetQuery({ page, limit: pageSize, searchKey, columnName, sortingOrder, user })
                .then((response) => {
                    if (response.code == 200 && response.status) {
                        setRoleList(response.data.data)
                        const { totalItems, totalPages, currentPage } = response.data
                        setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                    } else {
                        setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                        setRoleList([])
                    }
                }).catch((error) => {
                })
        } else if (isListPermission) {
            callGetQueryForCustomers({ page, limit: pageSize, searchKey, columnName, sortingOrder })
                .then((response) => {
                    if (response.code == 200 && response.status) {
                        setRoleList(response.data.data)
                        const { totalItems, totalPages, currentPage } = response.data
                        setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                    } else {
                        setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                        setRoleList([])
                    }
                }).catch((error) => {
                })
        }
    }

    const handleSortColumn = (option) => {
        setSortingOptions(option)
        const columnName = option.column;
        setColumnId(columnName)
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder)
        handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
    }

    const handleSearchFilter = (value, pageSize) => {
        setSearchValue(value)
        handlePageChange(1, pageSize, value);
    }

    const handleClearSearch = () => {
        setSearchValue("")
        handlePageChange(1, pageSize, "")
    }

    return (
            <div className="page-content">
                <Container fluid>
                    <h4 className="mb-4">QUERY LIST</h4>
                    <Row className="vertical-scroll">
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerV1
                                        columns={columns}
                                        data={roleList}
                                        pagination={pagination}
                                        handlePageChange={handlePageChange}
                                        handleSearchFilter={handleSearchFilter}
                                        sortOptions={sortingOptions}
                                        handleSortColumn={handleSortColumn}
                                        handleClearSearch={handleClearSearch}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
    );
};



export default Queries;
